// extracted by mini-css-extract-plugin
module.exports = {"card":"newscard-module--card--1iXCC"};